module.exports = __webpack_public_path__ + "static/media/AQI-Legend.6b60879c.png";